import { render, staticRenderFns } from "./ApartmentView.vue?vue&type=template&id=6744b2fd&"
import script from "./ApartmentView.vue?vue&type=script&lang=js&"
export * from "./ApartmentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports